import moment from "moment";
export const findObjectLength = (obj: any) => {
  return Object.keys(obj).length;
};
export const DateFormatTOString = (value: any) => {
  return moment(value).format("DD/MM/YYYY");
};
